import { SoilTestAPI, LabsAPI, TexturesAPI } from '@/api';
import { InvalidInputError } from '@/errors/invalid-input.error';

// TODO: Разобраться с разными видами наборов нутриентов ебанутая хуита

const default_form = {
  name: '',
  fieldId: 0,
  farmId: 0,
  methodId: 37,
  textureId: 0,
  isExtentions: true,
  layer_depth: null,
  avg_temp: null,
  cec: null,
  bulk: null,
  ec: null,
  ph: null,
  om: null,
  date: 0,
  data: [],
};

export default {
  namespaced: true,
  state: {

    form: JSON.parse(JSON.stringify(default_form)),
    extentions: [],
    labs: [],
    textures: [],

    maxNCount: null,

    is_creating: false,
    loading: false,

  },
  mutations: {
    setForm(state, form) {
      state.form = form;
    },
    clearForm(state) {
      state.form = JSON.parse(JSON.stringify(default_form));
    },
    setData(state, data) {
      state.form.data = data;
    },
    setCreateMode(state, mode) {
      state.is_creating = mode;
    },
    setExtentions(state, data) {
      state.extentions = data;
    },
    setLabs(state, data) {
      state.labs = data;
    },
    setTextures(state, data) {
      state.textures = data;
    },
    setLoading(state, flag) {
      state.loading = flag;
    },

    computeN(state, { use_n_form }) {
      const data = state.form.data;
      const NO3 = parseFloat(data.find(n => n.type === 'NNO3').value) || 0;
      const NH4 = parseFloat(data.find(n => n.type === 'NNH4').value) || 0;
      const NH2 = parseFloat(data.find(n => n.type === 'NNH2').value) || 0;
      const N = data.find(n => n.type === 'N');

      if(use_n_form)
        N.value = (NO3 + NH4 + NH2).toFixed(2)
      else N.value = 0

      state.maxNCount = (NO3 + NH4 + NH2);
    },

    clearN(state) {
      state.form.data.find(n => n.type === 'NNO3').value = 0
      state.form.data.find(n => n.type === 'NNH4').value = 0
      state.form.data.find(n => n.type === 'NNH2').value = 0
    },

    setMax(state, { value }) {
      state.maxNCount = value
    }

  },
  actions: {

    async loadTextures({ commit, dispatch, state, getters, rootGetters }) {
      commit('setTextures', await TexturesAPI.selectAll().then(res => res.data));
    },

    async loadLabs({ commit, dispatch, state, getters, rootGetters }) {
      commit('setLabs', await LabsAPI.getLabs().then(res => res.data.data.data));
    },

    async onLabSelect({ dispatch }, lab) {
      await dispatch('selectExtentions', lab);
      await dispatch('updateDefaultExtention');
    },

    async createTest({ commit, dispatch, state, getters, rootGetters }) {

      const form = { ...state.form }

      // TODO: remove later - тут добавляются интерпретации
      form.data = getters.addKirillInterpretations(form.data);

      form.data.forEach(e => {
        if(e.interpretation == 'None') e.interpretation = null;
      })

      const test = await SoilTestAPI.create(form).then(res => res.data);

      if(rootGetters['tests/sidebar/filters'].type == 'soil-anal') {
        dispatch('tests/sidebar/updateData', null, { root: true });
      }

      return test;
    },

    updateDefaultExtention({ commit, dispatch, state, getters, rootGetters }) {
      commit('setData', getters.data.map(n => {
        var exts;
        if (n.n_form) {
          exts = getters.getGetExtsByNutrient('N');
        } else {
          exts = getters.getGetExtsByNutrient(n.type);
        }
        let ext = exts.find(e => e.name == n.defaultExtension)
        
        if(exts.length) {
          n.ext = ext ? ext.id : exts[0].id
        }
        return n;
      }));
    },

    async deleteTest({ commit, dispatch, state, getters, rootGetters }) {
      await SoilTestAPI.delete(state.form.id);

      if(rootGetters['tests/sidebar/filters'].type == 'soil-anal') {
        dispatch('tests/sidebar/updateData', null, { root: true });
      }
    },

    async updateTest({ commit, dispatch, state, getters, rootGetters }) {

      const form = { ...state.form }
      // TODO: remove later - тут добавляются интерпретации
      form.data = getters.addKirillInterpretations(form.data);

      await SoilTestAPI.update(form.id, form);

      if(rootGetters['tests/sidebar/filters'].type == 'soil-anal') {
        dispatch('tests/sidebar/updateData', null, { root: true });
      }
    },

    async getSingle({ commit, dispatch, state, getters }, test) {

      commit('setLoading', true);
      const form = await SoilTestAPI.get(test).then(res => res.data);
      form.data = getters.parseDataToLatestVersion(form.data);
      commit('setForm', form);
      await dispatch('selectExtentions', form.methodId);
      commit('setLoading', false);
    },

    async selectExtentions({ commit }, lab) {
      commit(
        'setExtentions',
        await LabsAPI.getAllExtByLab(lab).then(res => res.data)
      );
    },

    initDefaultData({ commit, rootGetters, getters }) {
      commit('setData', getters.getFormat());
    },
  },
  getters: {

    form(state) {
      return state.form
    },

    labs(state) {
      return state.labs
    },

    textures(state) {
      return state.textures
    },

    /**
     * Вот это формат в котором должно отсылаться на сервер (Normal)
     */
    getFormat: (state, getters, rootState, rootGetters) => () => {
      var n_obj = rootGetters['nutrients/data'].find(item => item.key == 'N');

      return [
        ...rootGetters['nutrients/nForms'].map(n => {
          return {
            type: n.key,
            n_form: true,
            value: null,
            ext: null,
            interpretation: null,
            defaultExtension: n_obj.defaultExtension,
          }
        }),
        ...rootGetters['nutrients/data'].map(n => {
          return {
            type: n.key,
            value: null,
            n_form: false,
            ext: null,
            interpretation: null,
            defaultExtension: n.defaultExtension,
          }
        }).filter(n => ['NNO3', 'NNH4', 'NNH2', 'HCO3'].indexOf(n.type) == -1),
      ]
    },

    /**
     *
     * Это надо что бы если вдруг обновится список нутриентов
     * оно должно добавить недостающие нутриенты в нынешней дате (или удалить ненужные)
     */
    parseDataToLatestVersion: (state, getters, rootState, rootGetters) => data => {

      const format = getters.getFormat();
      // var nuts = rootGetters['nutrients/data'];

      // deleting filter
      data = data.filter(n => format.find(z => n.type == z.type));

      // add new nutrients
      const new_nutrients = format.filter(n => !data.find(z => n.type == z.type));

      // data.push(...new_nutrients);

      return [...new_nutrients,...data];
    },

    addKirillInterpretations: (state, getters) => data => {
      console.log('INTERPRETATIONS', data);
      return data.map(n => {
        if(!n.interpretation) {
          n.interpretation = getters.getWarningLevel(n.value, n.ext);
          n.interpretation = getters.renderWarningLevel(n.interpretation);
        }
        return n;
      });
    },

    isCreating(state) {
      return state.is_creating
    },

    /**
     *
     * @param {Number} val - value in ppm
     * @param {Number} ext - ext id
     */
    getWarningLevel: (state, getters) => (val, extId) => {
      var ext = getters['getGetExtById'](extId);

      if(!ext) {
        return null;
      }

      if(val === null) {
        return 0;
      }

      var lowNum = 0;
      var adequateNum = 0;
      var highNum = 0;

      if(ext.isComplex) {

        if(ext.nutrientTypeDependent) {

          const dep_nut = ext.data.refferenceNutrientName;

          const item = getters['data']
            .find(n => n.type === dep_nut);

          if(item.value === null) {
            throw new InvalidInputError({
              key: 'dep-nut-empty',
              nut: dep_nut,
              msg: `Fill ${dep_nut} nutrient`
            });
          }

          if(item.value < ext.data.min) {
            lowNum = ext.data.below.lowNum;
            adequateNum = ext.data.below.adequateNum;
            highNum = ext.data.below.highNum;
          }
          else if(item.value >= ext.data.min && item.value <= ext.data.max) {
            lowNum = ext.data.in.lowNum;
            adequateNum = ext.data.in.adequateNum;
            highNum = ext.data.in.highNum;
          }
          else {
            lowNum = ext.data.above.lowNum;
            adequateNum = ext.data.above.adequateNum;
            highNum = ext.data.above.highNum;
          }
        } else {
          const texture_id = getters['form'].textureId;

          if(texture_id) {
            const needed_range = ext.data.find(n => n.soilTextureId == texture_id)

            if(!needed_range) {
              return null;
            }

            lowNum = needed_range.lowNum;
            adequateNum = needed_range.adequateNum;
            highNum = needed_range.highNum;
          } else {
            throw new InvalidInputError({
              key: 'no-texture',
              msg: 'Select soil texture'
            });
          }
        }

      } else {
        lowNum = ext.lowNum;
        adequateNum = ext.adequateNum;
        highNum = ext.highNum;
      }

      if(val == 0) {
        return 0;
      }
      else if(val > 0 && val <= lowNum) {
        return 1;
      }
      else if(val >= lowNum && val <= adequateNum) {
        return 2;
      }
      else if(val >= adequateNum && val <= highNum) {
        return 3;
      }
      else if(val >= highNum) {
        return 4;
      }
      else {
        return null;
      }
    },

    renderWarningLevel: (state, getters) => lvl => {
      if(lvl === 0) {
        return 'None';
      }
      else if(lvl === 1) {
        return 'Low';
      }
      else if(lvl === 2) {
        return 'Adequate';
      }
      else if(lvl === 3) {
        return 'High';
      }
      else if(lvl === 4) {
        return 'Excessive';
      }
      else {
        return null;
      }
    },

    extentions(state) {
      return state.extentions;
    },

    data(state) {
      return state.form.data;
    },

    getGetExtsByNutrient: state => nut => {
      return state.extentions.filter(n => n.type === nut);
    },

    getGetExtById: state => ext => {
      return state.extentions.find(n => n.id === ext);
    },

    excludedNutrients(state) {
      return [
        'Cl',
      ];
    },

    isLoading(state) {
      return state.loading;
    },
  }
};
